import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { CostPriceLayout, KitLayout, ReOrderLayout } from '../Layout';
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    Selection
} from "devextreme-react/data-grid";
import "jspdf-autotable";
import axios from "axios";
import { MESSAGES } from "../../../../common/Messages";
import { PriceLevelColumns } from "../../../../const/Lookup";

function CostPriceTab(props) {
    const dataGrid = useRef(null);
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const [dataSource, setDataSource] = useState([]);
    const [selectedColoumns, setColoumns] = useState(null);
    
    // Expose grid ref to parent component
    useEffect(() => {
        if (props.onGridReady) {
            props.onGridReady.current = dataGrid;
        }
    }, [props.onGridReady]);
    
    // Resize grid when tab becomes visible
    useEffect(() => {
        if (props.isTabVisible && dataGrid.current && dataGrid.current.instance) {
            setTimeout(() => {
                if (dataGrid.current && typeof dataGrid.current.instance === 'function') {
                    const instance = dataGrid.current.instance();
                    if (instance && typeof instance.updateDimensions === 'function') {
                        instance.updateDimensions();
                    }
                }
            }, 150);
        }
    }, [props.isTabVisible]);
    
    useEffect(() => {
        const loadData = async () => {
            await fetchSummaryTotalsData();
        };
        loadData();
    }, [props.loadPriceDataGrid]);

    const fetchSummaryTotalsData = async () => {
        try {
            const res = await axios.get(
                `${window._env_.REACT_APP_APIS}/im/PriceCodes/GetPriceCodes`,
                {
                    params: {
                        ItemRowId: props.formFields.RItem,
                        ProfileRowId: props.formFields.ProfileRowId,
                        RPriceTable: props.formFields.RPriceTable,
                        PriceMethod: props.formFields.PriceMethod,
                        CalcMethod: props.formFields.CalcMethod,
                        AverageCost: props.formFields.AverageCost,
                        StandardCost: props.formFields.StandardCost,
                        RoundingMethod: props.formFields.RoundingMethod,
                        RoundingFactor: props.formFields.RoundingFactor,
                        LastCost: props.formFields.LastCost,
                        PriceBasis: props.formFields.PriceBasis,
                        PriceSource: props.formFields.PriceSource,
                        PriceLevelA: props.formFields.PriceLevelA,
                        PriceLevelB: props.formFields.PriceLevelB,
                        PriceLevelC: props.formFields.PriceLevelC,
                        PriceLevelD: props.formFields.PriceLevelD,
                        PriceLevelE: props.formFields.PriceLevelE,
                    }
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            if (res.data) {
                let priceLevels = res.data[0]?.NumberOfPriceLevels;
                let cols = [];
                if (priceLevels !== null) {

                    for (let i = 0; i < PriceLevelColumns.length; i++) {
                        const col = PriceLevelColumns[i];
                          cols.push(col);
                        if (col.key === priceLevels) {
                            break;
                        }
                    }
                }
                setColoumns(cols);
                setDataSource(res.data);
                // Resize grid after data is loaded
                setTimeout(() => {
                    if (dataGrid.current && typeof dataGrid.current.instance === 'function') {
                        const instance = dataGrid.current.instance();
                        if (instance && typeof instance.updateDimensions === 'function') {
                            instance.updateDimensions();
                        }
                    }
                }, 100);
            } else {
                console.warn(MESSAGES.FETCH_ERROR);
            }
        } catch (err) {
            console.log(err, MESSAGES.FETCH_ERROR);
        }
    };
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    var accessToken = props.oidc.user.access_token;
    const formRefs = useRef({});
    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
            }
        }
    };
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }
    const handleSelectionChange = useCallback((name, value, e) => {
    }, []);
    // Define columns as JSON


    const currencyFormat = { type: 'currency', precision: 4, useGrouping: true };

    return (
        <div className="lot-cost-price-tab-container">
            <style>{`
                .lot-cost-price-tab-container .sortable-lists {
                    height: 46vh !important;
                }
            `}</style>
            <FormField
                currrentUser={currentUser}
                layoutId='11760B81-178B-4353-B249-98D942740F7E'
                layoutName='IMLotDataEntryCostPriceForm'
                defaultFormSchema={CostPriceLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={(name, value, e) => props.handleFieldChange(name, value, e, formRefs)}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={() => props.costPriceFormLoad(formRefs)}
                handleSelectedItemChange={handleSelectionChange}
            />
            <div className="col-md-12">
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    id="gridContainer"
                    onContentReady={onContentReady}
                    dataSource={dataSource}
                    ref={dataGrid}
                    selectedRowKeys={selectedItemKeys}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    onSelectionChanged={handleCellValueChanged}
                    height='26vh'
                >
                    <Scrolling mode="standard" />
                    <Selection mode="single" />
                    <FilterRow visible={true} />
                    {props.formFields.RPriceTable != null && (
                        <Column dataType="string" dataField="FromQuantity" caption="From Quantity" format={{ type: 'fixedPoint', precision: 4, useGrouping: true }} />
                    )}
                    {selectedColoumns && selectedColoumns.map(col => (
                        <Column
                            key={col.dataField}
                            dataType={col.dataType}
                            dataField={col.dataField}
                            caption={col.caption}
                            format={currencyFormat}
                        />
                    ))}
                </DataGrid>
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CostPriceTab);
